
import {zip as observableZip,  Subscription, Observable ,  Subject } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { BookingDto, GetEventDto, ParticipantDto } from '../../models/training/training.models';
import { TrainingService } from '../../services/training.service';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { RouterService } from '../../services/routerService';
import { BookingStatus } from '../../models/training/training.enums';
import { forEach } from 'underscore';

@Component({
    selector: 'training/book',
    template: require('./training.book.component.html'),
    styles: [require('./training.shared.css'), require('./training.book.component.css')]
})
export class BookTrainingComponent implements OnInit, OnDestroy{

    event: GetEventDto;
    trainingService: TrainingService;
    routeParamsSub: Subscription;
    public form: FormGroup;
    private destroy$ = new Subject();
    costPerPerson: number;
    vatPerPerson: number;
    subscribed: boolean;
    supplierId: number;
    booking: BookingDto;

    constructor(trainingService: TrainingService,
        configuration: Configuration,
        helpers: Helpers,
        private router: Router,
        private route: ActivatedRoute,
        loggedInUserService: LoggedInUserService,
        private readonly routerService: RouterService) {

        this.trainingService = trainingService;
        this.event = new GetEventDto();

        var user = loggedInUserService.getCurrentUser();
        this.subscribed = !user.canAdHoc('notSubscribed');
        this.supplierId = user.supplierId;
    }

    ngOnInit(): void {

        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            const id = +params['id'];

            var eventObservable = this.trainingService.getEvent(id);

            observableZip(
                eventObservable,
                (event: GetEventDto) => ({ event }))
                .subscribe(results => {
                    this.event = results.event;

                    if (this.subscribed) {
                        this.costPerPerson = this.event.subscriberCost;
                    }
                    else {
                        this.costPerPerson = this.event.supplierCost;
                    }

                    this.vatPerPerson = this.costPerPerson * 0.2;

                    var dto = new BookingDto();
                    dto.eventId = this.event.id;
                    dto.customerId = this.supplierId;

                    var eventObservable2 = this.trainingService.getBookingForCustomer(dto);

                    observableZip(
                        eventObservable2,
                        (booking: BookingDto) => ({ booking }))
                        .subscribe(results => {
                            this.booking = results.booking;

                            if (this.booking != null) {
                                this.numPlaces.setValue(this.booking.numPlaces);
                                this.generateResourceForm();
                            }
                        });
                });
        });

        this.form = new FormGroup({
            'numPlaces': new FormControl(null, { validators: [Validators.required] }),
            'participants': new FormArray([])
        });

        this.numPlaces.valueChanges
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                this.generateResourceOrig();
            });

        this.numPlaces.setValue(1);

        this.generateResourceForm();        
    }

    ngOnDestroy() {
        this.destroy$.next();
    }

    createResource() {
        return new FormGroup({
            'participantName': new FormControl(null, { validators: Validators.required }),
            'email': new FormControl(null, { validators: Validators.required })
        });
    }

    createResourcePopulated(name: string, email: string) {
        return new FormGroup({
            'participantName': new FormControl(name, { validators: Validators.required }),
            'email': new FormControl(email, { validators: Validators.required })
        });
    }

    generateResourceOrig() {
        while (this.participants.length) {
            this.participants.removeAt(0);
        }
        for (let x = 0; x < this.numPlaces.value; x++) {
                this.participants.push(this.createResource());
        }
    }

    generateResourceForm() {
        while (this.participants.length) {
            this.participants.removeAt(0);
        }
        for (let x = 0; x < this.numPlaces.value; x++) {

            if (this.booking != null) {

                if (this.booking.participants.length > x) {
                    this.participants.push(this.createResourcePopulated(this.booking.participants[x].name, this.booking.participants[x].email));
                }
                else {
                    this.participants.push(this.createResource());
                }
                
            }
            else {
                this.participants.push(this.createResource());
            }            
        }
    }

    add() {
        console.log(this.form.value);
    }

    get numPlaces() {
        return this.form.get('numPlaces');
    }

    get participants() {
        return this.form.get('participants') as FormArray;
    }

    public totalCostExcVat() {
        return (this.numPlaces.value * this.costPerPerson).toFixed(2);
    }

    public totalCost() {
        return (this.numPlaces.value * 1.2 * this.costPerPerson).toFixed(2);
    }

    public totalVat() {
        return (this.numPlaces.value * 0.2 * this.costPerPerson).toFixed(2);
    }

    submit() {
        const dto = new BookingDto();

        dto.numPlaces = this.numPlaces.value;
        dto.cost = this.numPlaces.value * 1.2 * this.costPerPerson;
        dto.customerId = this.supplierId;
        dto.eventId = this.event.id;
        dto.status = BookingStatus.Pending;
        dto.formData = this.form.value;

        if (this.booking != null) {
            dto.id = this.booking.id;
        }

        this.trainingService.book(dto).subscribe((response: any) => {
            this.routerService.router.navigateByUrl(`/training/payment/${response.value}`);
        },
            () => {
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/training/training.book.component.ts